import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from "@mui/material/Tooltip";

function ZeroInventoryTable(props) {
    let columns = [
        {
            field: 'delete',
            headerName: '',
            flex: 0.5,
            minWidth: 50,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <IconButton
                    aria-label="delete"
                    size="small"
                    onClick={() => props.handleDelete(params.row.sku)}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            ),
        },
        {
            field: 'sku',
            headerName: "SKU",
            flex: 1,
            editable: false,
            minWidth: 50,
            hide: false,
            display: true
        },
        {
            field: 'date_added',
            headerName: "Date Added",
            flex: 1,
            editable: false,
            minWidth: 120,
            renderCell: (params) => {
                let rawDate = params.row.date_added;
                if (!rawDate) return '';

                const date = new Date(rawDate);
                const formatted = date.toLocaleString("en-US", {
                    timeZone: "America/New_York",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                });

                return (
                    <Tooltip title={formatted}>
                        <Box style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {formatted}
                        </Box>
                    </Tooltip>
                );
            },
        }
    ]


    return(
        <Box className={props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
            <DataGrid
                rows={props.zeroedOutInventory}
                className={props.isMobile ? "mobile-table" : "desktop-table"}
                columns={columns}
                rowsPerPageOption = {[25, 50, 100]}
                sortModel = {[{field:'date_added'}]}
                getRowId = {(row) => row.sku}
            />
        </Box>   
    )


}

export default ZeroInventoryTable;